// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:34:50.239Z
// Property: New River Forest (ID: 6767906449167581)
// Collections: 10 amenities, 3 floorplans (live), 29 photos, 45 POIs, 3 reviews, 3 virtual tours, 5 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167581",
  "property_external_id": "1661777",
  "property_zillow_url": "https://www.zillow.com/apartments/bluffton-sc/new-river-forest/CjjCSQ/",
  "property_apartments_url": "https://www.apartments.com/new-river-forest-bluffton-sc/64dl0zt/",
  "property_google_business_url": "https://www.google.com/maps/place/New+River+Forest+-+a+Quinn+Residence/@32.2400832,-80.9891433,837m/data=!3m2!1e3!4b1!4m6!3m5!1s0x88fb890dfa3c3177:0x720b255ba1fe9a1c!8m2!3d32.2400832!4d-80.9891433!16s%2Fg%2F11pxg7p4ww?entry=ttu&g_ep=EgoyMDI2MDkyMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57151089588",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "new-river-forest",
  "property_name": "New River Forest",
  "property_website_url": "https://www.newriverforest.com",
  "property_domain": "https://www.newriverforest.com",
  "property_address": "36 Kelsey Lane",
  "property_full_address": "36 Kelsey Lane, Bluffton, SC 29910",
  "property_address_1": "36 Kelsey Lane",
  "property_address_2": null,
  "property_address_city": "Bluffton",
  "property_address_state": "SC",
  "property_address_zip_full": "29910",
  "property_address_zip": "29910",
  "property_address_country": "US",
  "property_address_county": "Beaufort County",
  "property_neighborhood_address": "New Riverside",
  "property_address_latitude": "32.2397838",
  "property_address_longitude": "-80.98661829999999",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(844) 697-1165",
  "property_call_tracking_phone": "844-697-1165",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes",
  "property_short_description": "<p><strong>New rental-home living in Bluffton’s New Riverside area.</strong> Explore three- and four-bedroom homes with granite countertops, stainless steel appliances, smart-home technology, private fenced yards, and lawn maintenance handled for you.</p>",
  "property_long_description": "<p><strong>New rental-home living in Bluffton’s New Riverside area.</strong> New River Forest gives you the ease of a three- or four-bedroom home with polished everyday details: granite countertops, stainless steel appliances, luxury flooring, spacious closets, in-unit laundry, smart-home technology, private fenced yards, and lawn maintenance handled for you. Explore available <a href=\"/floor-plans\">three- and four-bedroom layouts</a> designed for comfortable living, hosting, working from home, and unwinding outdoors.</p><p>Beyond your front door, the community keeps the Lowcountry lifestyle close with a pool, clubhouse, dog park, and playground, plus quick access to New Riverside Village and May River Commons for nearby shopping and dining. New Riverside Barn Park and the New River Linear Trail add open lawns, picnic space, and scenic paths close to home, while Old Town Bluffton, the May River, Hilton Head Island, and Savannah are all within reach when you want waterfront restaurants, galleries, beaches, or a bigger day out. See more <a href=\"/amenities\">amenities</a> and explore the <a href=\"/neighborhood\">Bluffton neighborhood</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-8fb6-724e-b3fb-97022e93a596.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a street lined with new construction townhomes and houses.",
    "public_id": "019fc85d-8fb6-724e-b3fb-97022e93a596",
    "storage_key": "property/6767906449167581/019fc85d-8fb6-724e-b3fb-97022e93a596.webp",
    "width": 1280,
    "height": 900
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167581/01a0c018-72b4-70d3-b97c-20f86f373969.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c018-72b4-70d3-b97c-20f86f373969",
    "storage_key": "property/6767906449167581/01a0c018-72b4-70d3-b97c-20f86f373969.mp4",
    "thumbnail_key": "property/6767906449167581/01a0c018-72b4-70d3-b97c-20f86f373969_thumb.webp",
    "size_bytes": 18754545,
    "classification": "Community",
    "title": "Explore Our Beautiful Community and Amenities",
    "description": "Discover our stunning community featuring a resort-style pool, clubhouse, and well-maintained grounds. Experience the perfect blend of comfort and recreation."
  },
  "property_total_units": "113",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": "5",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.03539823008849",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge fee $10.95 (bi-annual filter change, exterior pest control, 24-hour emergency maintenance response, positive credit reporting), landscaping $95, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval from Quinn Property Management. Pet screening is mandatory before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time non-refundable pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply; pet screening required before move-in.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://newriverforest.securecafe.com/onlineleasing/new-river-forest/floorplans.aspx",
  "property_resident_portal_url": "https://newriverforest.securecafenet.com/residentservices/new-river-forest/userlogin",
  "property_apply_now_url": "https://newriverforest.securecafe.com/onlineleasing/new-river-forest/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a0d000-86d7-7264-8d3c-08235de69cb7.webp",
  "property_primary_logo_media": {
    "alt_text": "New River Forest logo",
    "public_id": "01a0d000-86d7-7264-8d3c-08235de69cb7",
    "storage_key": "property/6767906449167581/01a0d000-86d7-7264-8d3c-08235de69cb7.webp",
    "width": 138,
    "height": 62
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a0d001-2abd-716d-bb16-1692e41df85c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0d001-2abd-716d-bb16-1692e41df85c",
    "storage_key": "property/6767906449167581/01a0d001-2abd-716d-bb16-1692e41df85c.webp",
    "width": 138,
    "height": 62
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a0d001-1e69-77df-a0f0-1650e5c897fb.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0d001-1e69-77df-a0f0-1650e5c897fb",
    "storage_key": "property/6767906449167581/01a0d001-1e69-77df-a0f0-1650e5c897fb.webp",
    "width": 138,
    "height": 62
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#20150e",
  "property_secondary_color": "#045656",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 3",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "3",
  "property_sqft_range": "1722 - 2065",
  "property_sqft_min": "1722",
  "property_sqft_max": "2065",
  "property_price_range": "2700 - 3424",
  "property_price_min": "2592",
  "property_price_max": "3415",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/people/New-River-Forest/100063698604730/",
  "property_instagram_url": "https://www.instagram.com/newriverforest/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJdzE8-g2J-4gRHJr-oVslC3I",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to New River Forest",
  "property_home_romance_title": "Experience Comfort and Joy in Your New Rental Home",
  "property_home_amenities_blurb": "<p><strong>Amenities that make Bluffton living feel effortless.</strong> At New River Forest, sunny pool days, clubhouse meetups, pond-side views, and a pet park set the tone outside. Inside, granite countertops, stainless steel appliances, wood-style flooring, in-home laundry, generous closets, private yards and patios, and added security features bring everyday comfort into focus.</p>",
  "property_home_floorplans_blurb": "<p><strong>Single-family rental space, simplified.</strong> Explore three- and four-bedroom homes in Bluffton with open kitchens, dining areas, and gathering spaces built for everyday flow. Two-car garages, kitchen pantries, spacious closets, and fenced back yards add room where it counts, while granite countertops, stainless steel appliances, luxury flooring, in-unit laundry, and smart-home features keep each layout polished and move-in ready.</p>",
  "property_home_gallery_blurb": "<p><strong>See New River Forest in focus.</strong> Preview open living spaces, granite kitchens with stainless steel finishes, wood-style flooring, generous closets, and everyday conveniences like in-home laundry. Then picture the Lowcountry setting with fenced yards, patios, poolside views, clubhouse spaces, a pet park, pond, and playground. Browse the full gallery to get a closer look at three- and four-bedroom rental homes in Bluffton.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Bluffton convenience with Lowcountry scenery close by.</strong> New River Forest puts everyday stops along New Riverside within easy reach, from Compass Commons and New Riverside Village to Publix-anchored errands and wood-fired pizza at Local Pie. Head toward Old Town for Calhoun Street galleries, Bluffton Farmers Market, Oyster Factory Park, and May River views—then branch out to Hilton Head beaches, Savannah, and nearby trails.</p>",
  "property_home_reviews_blurb": "<p><strong>Service that stands out.</strong> Resident reviews highlight professional communication, thoughtful support, and a welcoming experience from the very first conversation. Gabrielle Dellefave is often mentioned by name for making move-ins feel smooth and well-supported, while the broader team earns praise for kindness, care, and responsiveness. Read more to see why the experience at New River Forest keeps earning standout feedback.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a Bluffton routine with room to wander.</strong> From New River Forest, you’re close to the fast-growing New Riverside corridor, where Compass Commons and New Riverside Village bring everyday stops, local dining, and services into easy reach—think wood-fired pizza at Local Pie, quick errands near the Publix-anchored May River Crossing, and new favorites opening around the village green.</p><p>When you want the classic Lowcountry side of Bluffton, follow May River Road toward Old Town for Calhoun Street galleries, patios, the Farmers Market of Bluffton, Oyster Factory Park, and river views by the Church of the Cross. Nearby routes connect you to Hilton Head beaches, Savannah weekends, and trails and greenspace close to home. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Daily comfort starts in the details at New River Forest.</strong> Spend sunny afternoons by the pool, meet up in the clubhouse, enjoy the pond-side setting, or let four-legged residents make the most of the pet park—then come home to space that feels easy to live in.</p><p>Inside these Bluffton rental homes, polished finishes do more than look good: granite countertops, stainless steel appliances, durable wood-style flooring, electronic thermostats, in-home laundry, and generous closets help streamline everyday routines. Private yards and patios extend your living space outdoors, while a security system adds another layer of convenience. See how it all comes together in the <a href=\"/gallery\">photo gallery</a>, review the <a href=\"/pet-policy\">pet-friendly details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Your new Bluffton rental home starts here.</strong> Choose a three- or four-bedroom layout with granite countertops, stainless steel appliances, luxury flooring, smart-home technology, in-unit laundry, and a private fenced yard with lawn maintenance handled. When you’re ready, start your online application for New River Forest today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Reach out to the New River Forest leasing team for help with three- and four-bedroom rental-home availability, smart-home features, private fenced yards, lawn maintenance, or getting here in Bluffton’s New Riverside area.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at New River Forest?</strong> Start here for quick answers about the community, leasing, home features, and everyday living in Bluffton’s New Riverside area. If you need more details, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare layouts with real home-style space.</strong> New River Forest makes the search straightforward with the three-bedroom Cumberland and four-bedroom Sapelo and Beaufort floor plans, each designed as a single-family rental home in Bluffton. Open living areas connect the kitchen, dining, and main gathering space, while two-car garages, kitchen pantries, spacious closets, and fenced back yards add practical room for everyday routines.</p><p>Inside, polished finishes like granite countertops, stainless steel appliances, luxury flooring, in-unit laundry, and smart-home features give each layout a clean, move-in-ready feel. Browse the available floor plan cards below, compare pricing and availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which home feels right in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the space before you step inside.</strong> Browse bright, home-style interiors where open living areas flow into crisp kitchens with granite counters, stainless steel finishes, and room to gather around the island. Photos highlight the details that make New River Forest feel polished yet practical, from wood-style floors and generous closets to laundry placed right where daily routines need it.</p><p>Outside, the gallery shifts to the easy Lowcountry backdrop: fenced yards and patios, sunny poolside views, the clubhouse, pet park, pond, and playground moments around the community. Use the photos to compare the feel of spacious three- and four-bedroom <a href=\"/floor-plans\">rental home layouts</a>, then take a closer look with <a href=\"/virtual-tours\">virtual tours</a> or plan your visit in Bluffton.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore New Riverside living on the map.</strong> Find available three- and four-bedroom rental homes, then zoom out to see how New River Forest connects you to nearby shopping, dining, parks, scenic trails, Old Town Bluffton, the May River, Hilton Head Island, and Savannah.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, nap, and settle in.</strong> At New River Forest, pet-friendly rental-home living gives your dogs and cats more than a place to stay—it gives daily routines room to breathe. Let your dog burn off energy at the on-site pet park or pet play area, then head back to a home with a yard, patio, hard-surface flooring, and in-home laundry that help make pet life simpler. With spacious three- and four-bedroom layouts and a community setting close to dog-friendly parks and trails around Bluffton, it’s easy to build walks, playtime, and fresh-air breaks into the day. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Share the ease of New River Forest.</strong> Invite a friend to discover new rental-home living with three- and four-bedroom layouts, polished finishes, smart-home technology, private fenced yards, and lawn maintenance handled. Send a referral today and let them see what makes life here feel so easy.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access made easy.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account for your New River Forest rental home—so everyday details stay as polished and convenient as the granite countertops, smart-home technology, in-unit laundry, fenced yards, and lawn maintenance that help make home feel effortless.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying.</strong> Reviews for New River Forest consistently point to thoughtful service, professional communication, and a welcoming experience from the first conversation onward.</p><p>Residents call out Gabrielle Dellefave by name, describing her as “outstanding” and crediting her with making the move-in experience feel smooth and well-supported. As you read the full reviews, you’ll see repeated appreciation for a team that treats people with kindness, care, and professionalism—helping New River Forest feel like a place where your questions are heard and your experience matters.</p>",
  "property_created_at": "1785772850322",
  "property_scheduletour_blurb": "<p><strong>See new rental-home living up close.</strong> Tour three- and four-bedroom homes in Bluffton’s New Riverside area with granite countertops, stainless steel appliances, luxury flooring, spacious closets, smart-home technology, in-unit laundry, private fenced yards, and lawn maintenance handled for you. Schedule your visit and picture everyday living with more room to unwind.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we received your inquiry.</strong><br>New River Forest’s leasing team will be in touch soon. In the meantime, picture new rental-home living in Bluffton with three- and four-bedroom layouts, polished finishes, smart-home technology, private fenced yards, and lawn maintenance handled for you.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. New River Forest",
  "property_seo_title_home": "New River Forest |  Apartments in Bluffton, SC",
  "property_seo_description_home": "Welcome to New River Forest in Bluffton, SC! Enjoy spacious layouts, luxury amenities, and smart-home technology. Find your perfect home today!",
  "property_seo_title_floorplans": "Floor Plans | Bluffton, SC Apartments for Rent",
  "property_seo_description_floorplans": "Unveil your ideal living space at New River Forest in Bluffton, SC. Choose from spacious 3 & 4-bedroom floor plans tailored for comfort and style.",
  "property_seo_title_amenities": "Amenities | Bluffton, SC Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at New River Forest in Bluffton, SC! Enjoy spacious floor plans, modern amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Bluffton, SC",
  "property_seo_description_gallery": "Discover luxury at New River Forest, Bluffton, SC! Relax by the pool or at our dog park—your dream home is just a photo away!",
  "property_seo_title_virtualtours": "Virtual Tours | New River Forest Apartments",
  "property_seo_description_virtualtours": "Experience the charm of New River Forest in Bluffton, SC! Take our virtual tour and find your perfect four or three-bedroom apartment today!",
  "property_seo_title_interactivemap": "Interactive Map | New River Forest Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at New River Forest in Bluffton, SC! Use our interactive map to explore spacious layouts, luxury amenities, and vibrant community life.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bluffton, SC",
  "property_seo_description_neighborhood": "Discover Bluffton, SC! Enjoy vibrant living at New River Forest with three- and four-bedroom options and local favorites just a stroll away.",
  "property_seo_title_contact": "Contact Us | New River Forest",
  "property_seo_description_contact": "Connect with New River Forest in Bluffton, SC! Our leasing team is ready to help you find the perfect three or four-bedroom apartment. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Bluffton, SC",
  "property_seo_description_faqs": "Find answers to your pressing questions about New River Forest in Bluffton, SC. Explore our amenities and learn why your next home awaits here!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bluffton, SC",
  "property_seo_description_reviews": "Experience life at New River Forest in Bluffton, SC! From spacious layouts to resort-style amenities, see why residents love calling this community home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Bluffton, SC",
  "property_seo_description_applynow": "Experience luxury living at New River Forest, Bluffton, SC! Spacious apartments with modern amenities like a dog park, pool, and smart tech. Lease online!",
  "property_seo_title_residentaccess": "Resident Access | New River Forest",
  "property_seo_description_residentaccess": "Seamlessly manage life at New River Forest! Log in to your resident portal for rent payments, maintenance requests, and community updates in Bluffton, SC.",
  "property_seo_title_referafriend": "Refer A Friend | New River Forest",
  "property_seo_description_referafriend": "Share the charm of New River Forest! Refer a friend to our Bluffton community and enjoy great neighbors and even greater memories in your new home!",
  "property_seo_title_scheduletour": "Schedule a Tour | New River Forest",
  "property_seo_description_scheduletour": "Experience the charm of New River Forest in Bluffton, SC. Schedule your tour today and envision your new home surrounded by nature’s beauty!",
  "property_seo_title_privacy": "Privacy Policy | New River Forest",
  "property_seo_description_privacy": "At New River Forest in Bluffton, SC, your privacy matters. Dive into our commitment to safeguarding your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | New River Forest",
  "property_seo_description_accessibility": "At New River Forest in Bluffton, SC, we champion digital inclusion. Experience a community where accessibility meets comfort—your well-being is our priority.",
  "property_seo_title_sitemap": "Sitemap | New River Forest",
  "property_seo_description_sitemap": "Uncover every corner of New River Forest in Bluffton, SC! Navigate our sitemap to find your perfect home, community perks, and so much more.",
  "property_seo_title_thankyou": "Thank You | New River Forest",
  "property_seo_description_thankyou": "Thank you for reaching out to New River Forest in Bluffton, SC! Our team will connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Bluffton, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793286854617",
  "amenities": [
    {
      "id": "ec_21e8f085b3a094bb60802478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122615924",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13ad02001cb139026f92782f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122203716",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8eb920439f9b70d8af2f1385",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122203737",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc304ddc973a35e68a94a995",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122615929",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8cccf4597cfcd42d4db1629",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122615928",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_855b620a8504bd6dc11a3b4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122615925",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a05047c25b4fdd4a419ebd07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122615926",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ec19834ddda75bfa167cbea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122615927",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dac7c439a8245a832576ec4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122615930",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ed6e8b87b3abd5e462cc2d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "122203740",
      "title": "Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d7519ba8eda7714c75ae4b5e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-8fb6-724e-b3fb-97022e93a596.webp",
      "image_media": {
        "alt_text": "Aerial view of a street lined with new construction townhomes and houses.",
        "public_id": "019fc85d-8fb6-724e-b3fb-97022e93a596",
        "storage_key": "property/6767906449167581/019fc85d-8fb6-724e-b3fb-97022e93a596.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover the charm of our community with beautifully constructed homes, featuring spacious interiors and modern amenities, all set within a serene neighborhood.",
      "link": "false",
      "alt_text": "A residential street with houses on both sides and cars parked on the side.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/New-River-Forest-Aerial%20(1).jpg"
    },
    {
      "id": "ec_619b3dac894c3bcf02034146",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9e3c-753a-800a-7cc822d99960.webp",
      "image_media": {
        "alt_text": "Exterior of building with swimming pool and lounge chairs.",
        "public_id": "019fc85d-9e3c-753a-800a-7cc822d99960",
        "storage_key": "property/6767906449167581/019fc85d-9e3c-753a-800a-7cc822d99960.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling outdoor swimming pool and comfortable lounge chairs, perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "A white house with a pool in the backyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/New-River-Forest-Aerial%20(4).jpg"
    },
    {
      "id": "ec_888c3a702f598532a8779148",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9eba-744a-81a1-136261e28120.webp",
      "image_media": {
        "alt_text": "Suburban street with houses and trees.",
        "public_id": "019fc85d-9eba-744a-81a1-136261e28120",
        "storage_key": "property/6767906449167581/019fc85d-9eba-744a-81a1-136261e28120.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "A picturesque street lined with charming houses and lush green trees, offering a serene and inviting community atmosphere.",
      "link": "false",
      "alt_text": "A curvy road in a residential area with houses on both sides.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/New-River-Forest-Aerial%20(3).jpg"
    },
    {
      "id": "ec_8a1622c6e1c773f5a45e8941",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-a0c7-769a-a2ec-116248acabe9.webp",
      "image_media": {
        "alt_text": "Aerial view of a new housing development with rows of houses and a pond.",
        "public_id": "019fc85d-a0c7-769a-a2ec-116248acabe9",
        "storage_key": "property/6767906449167581/019fc85d-a0c7-769a-a2ec-116248acabe9.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover this beautiful new development featuring modern homes surrounded by lush greenery and a serene pond, offering a peaceful and picturesque living environment.",
      "link": "false",
      "alt_text": "Aerial view of a new housing development with rows of houses and a pond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/New-River-Forest-Aerial%20(2).jpg"
    },
    {
      "id": "ec_45c7e34833ea8e30713fe36d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9dd3-7357-8078-7aaa31da6627.webp",
      "image_media": {
        "alt_text": "Exterior of a white townhouse with a garage and front door, surrounded by trees.",
        "public_id": "019fc85d-9dd3-7357-8078-7aaa31da6627",
        "storage_key": "property/6767906449167581/019fc85d-9dd3-7357-8078-7aaa31da6627.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming townhouse exterior featuring a pristine white facade, a convenient garage, and welcoming front door, set against a backdrop of lush green trees.",
      "link": "false",
      "alt_text": "A white house with a black door and a garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-exterior(1).jpg"
    },
    {
      "id": "ec_0053f4cae87fa9c29e20e923",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9c7f-72cb-8337-3c86dac7984f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "019fc85d-9c7f-72cb-8337-3c86dac7984f",
        "storage_key": "property/6767906449167581/019fc85d-9c7f-72cb-8337-3c86dac7984f.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, top-of-the-line stainless steel appliances, a large island with seating, and granite countertops. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-kitchen(1).jpg"
    },
    {
      "id": "ec_d4eb8b68ee62fbe33f49c6ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-a670-7237-af9c-f9f7516c666b.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and adjacent kitchen with island and bar stools.",
        "public_id": "019fc85d-a670-7237-af9c-f9f7516c666b",
        "storage_key": "property/6767906449167581/019fc85d-a670-7237-af9c-f9f7516c666b.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious living area flowing into a modern kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "A living room with a couch, a coffee table, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-living.jpg"
    },
    {
      "id": "ec_694e7e7acb5db811a20abf13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-a786-746c-8d36-543520f18a76.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and large mirror.",
        "public_id": "019fc85d-a786-746c-8d36-543520f18a76",
        "storage_key": "property/6767906449167581/019fc85d-a786-746c-8d36-543520f18a76.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious double vanity bathroom featuring granite countertops, ample counter space, and a large mirror, perfect for any apartment.",
      "link": "false",
      "alt_text": "A bathroom with a double sink vanity and a large mirror above it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-bath.jpg"
    },
    {
      "id": "ec_89d2410d00c589bd500c6662",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-e3c7-74b2-bc8f-d43b966d49f5.webp",
      "image_media": {
        "alt_text": "A picturesque tree-lined road with Spanish moss hanging from ancient oak trees.",
        "public_id": "01a188eb-e3c7-74b2-bc8f-d43b966d49f5",
        "storage_key": "property/6767906449167581/01a188eb-e3c7-74b2-bc8f-d43b966d49f5.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Experience the charm and natural beauty of our community, with stunning live oak trees creating a memorable canopy over the drive.",
      "link": "false",
      "alt_text": "A tree-lined road with a clear blue sky above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/bluffton.jpg"
    },
    {
      "id": "ec_f4c362837cdd95152a2ab007",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-e364-77c7-9693-fb857db9660a.webp",
      "image_media": {
        "alt_text": "Exterior view of a white two-story house with a two-car garage and a black front door.",
        "public_id": "01a188eb-e364-77c7-9693-fb857db9660a",
        "storage_key": "property/6767906449167581/01a188eb-e364-77c7-9693-fb857db9660a.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming two-story home featuring a spacious two-car garage, elegant black shutters, and a welcoming black front door, nestled amongst lush greenery.",
      "link": "false",
      "alt_text": "A white house with a black roof and a black door is surrounded by trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/sapelo.jpg"
    },
    {
      "id": "ec_2c048c0987d0b3f8a7afefba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-e566-704a-88cc-2f82fd8d3f76.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with newly constructed houses on a curving street, surrounded by trees.",
        "public_id": "01a188eb-e566-704a-88cc-2f82fd8d3f76",
        "storage_key": "property/6767906449167581/01a188eb-e566-704a-88cc-2f82fd8d3f76.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Explore this charming suburban neighborhood featuring modern homes with pristine landscaping and tree-lined streets, offering a peaceful residential setting.",
      "link": "false",
      "alt_text": "A suburban neighborhood with houses and a road.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/community-2(1).jpg"
    },
    {
      "id": "ec_579d4c4fb5286252436c6f9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-e31e-76ad-ae31-5b322366ac93.webp",
      "image_media": {
        "alt_text": "Living room with a ceiling fan and two windows.",
        "public_id": "01a188eb-e31e-76ad-ae31-5b322366ac93",
        "storage_key": "property/6767906449167581/01a188eb-e31e-76ad-ae31-5b322366ac93.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious living room with a ceiling fan, two large windows, and wood-look flooring, leading to a staircase and kitchen area.",
      "link": "false",
      "alt_text": "A room with a ceiling fan and wooden flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/sapelo-living(2).jpg"
    },
    {
      "id": "ec_e3559760dac830725aa21d33",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-e324-731d-8a21-23e595536a5c.webp",
      "image_media": {
        "alt_text": "Exterior of a white townhouse with a garage, front door, and manicured landscaping.",
        "public_id": "01a188eb-e324-731d-8a21-23e595536a5c",
        "storage_key": "property/6767906449167581/01a188eb-e324-731d-8a21-23e595536a5c.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "View of the exterior of a charming white townhouse, featuring a spacious garage and an inviting front entrance, surrounded by lush pine trees.",
      "link": "false",
      "alt_text": "A white house with a black door and a garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-exterior(2).jpg"
    },
    {
      "id": "ec_39e7972cf6ec734e7f776417",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-efff-7308-b3e2-01cd4e7fab9a.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and manicured lawns.",
        "public_id": "01a188eb-efff-7308-b3e2-01cd4e7fab9a",
        "storage_key": "property/6767906449167581/01a188eb-efff-7308-b3e2-01cd4e7fab9a.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Explore this charming suburban neighborhood featuring beautiful homes with well-maintained yards, perfect for family living.",
      "link": "false",
      "alt_text": "A suburban neighborhood with houses and cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/community-1.jpg"
    },
    {
      "id": "ec_720cbc82971c1d724f18f3f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-f154-77cb-a1ea-6f4945ca9e82.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a188eb-f154-77cb-a1ea-6f4945ca9e82",
        "storage_key": "property/6767906449167581/01a188eb-f154-77cb-a1ea-6f4945ca9e82.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and an island perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with a refrigerator, oven, and microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/sapelo-kitchen(1).jpg"
    },
    {
      "id": "ec_ea319805787157a5382302a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-f1db-70fb-909d-3a88bb71080e.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and mirrored medicine cabinets.",
        "public_id": "01a188eb-f1db-70fb-909d-3a88bb71080e",
        "storage_key": "property/6767906449167581/01a188eb-f1db-70fb-909d-3a88bb71080e.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample lighting, and a view into a bedroom.",
      "link": "false",
      "alt_text": "A bathroom with a double sink vanity and a large mirror above it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-bath(1).jpg"
    },
    {
      "id": "ec_117f7dd169f3025c59a18ea0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-f2f2-7638-a7ad-d4b8779af73f.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story house with a garage and front door.",
        "public_id": "01a188eb-f2f2-7638-a7ad-d4b8779af73f",
        "storage_key": "property/6767906449167581/01a188eb-f2f2-7638-a7ad-d4b8779af73f.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Charming two-story home featuring a two-car garage, welcoming front porch, and classic architectural details.",
      "link": "false",
      "alt_text": "A two-story house with a garage and a front door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/beaufort.jpg"
    },
    {
      "id": "ec_127d16e337d33c6bb54ff2bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-f41b-761b-8554-c57c0a3039eb.webp",
      "image_media": {
        "alt_text": "Aerial view of a new housing development under construction, showing homes in various stages of completion and a pond.",
        "public_id": "01a188eb-f41b-761b-8554-c57c0a3039eb",
        "storage_key": "property/6767906449167581/01a188eb-f41b-761b-8554-c57c0a3039eb.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Experience modern living in this developing community. Homes are being built with quality and comfort in mind, nestled beside a serene pond and surrounded by lush greenery.",
      "link": "false",
      "alt_text": "A bird's eye view of a construction site surrounded by trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/community-3(1).jpg"
    },
    {
      "id": "ec_d100a4dcc832386c71d47565",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-fc16-7185-8e9d-45e039d875ae.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower, and double vanity sinks.",
        "public_id": "01a188eb-fc16-7185-8e9d-45e039d875ae",
        "storage_key": "property/6767906449167581/01a188eb-fc16-7185-8e9d-45e039d875ae.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a pristine white bathtub and shower, complemented by a granite double vanity and modern fixtures. A small window above the tub allows natural light.",
      "link": "false",
      "alt_text": "A white bathroom with a tub, sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/sapelo-bath(1).jpg"
    },
    {
      "id": "ec_bd3985e7ba5b70e460c44e7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-fd3d-7046-9d54-949b77537f50.webp",
      "image_media": {
        "alt_text": "View of a waterfront property with docks and gazebos.",
        "public_id": "01a188eb-fd3d-7046-9d54-949b77537f50",
        "storage_key": "property/6767906449167581/01a188eb-fd3d-7046-9d54-949b77537f50.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Enjoy the coastal lifestyle with access to docks and scenic waterfront views.",
      "link": "false",
      "alt_text": "A pier with a green roof and a boat docked at the end.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/bluffton-2.jpg"
    },
    {
      "id": "ec_592d639f0ee71b14d7cba882",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-fd90-7608-8992-e4a82c37edab.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with hardwood floors and white cabinets.",
        "public_id": "01a188eb-fd90-7608-8992-e4a82c37edab",
        "storage_key": "property/6767906449167581/01a188eb-fd90-7608-8992-e4a82c37edab.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious kitchen and living area featuring modern white cabinets, stainless steel appliances, and beautiful hardwood flooring.",
      "link": "false",
      "alt_text": "A spacious kitchen with wooden floors and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/beaufort-living.jpg"
    },
    {
      "id": "ec_9ee2569ae3b56f789a5317dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-fdcb-76d8-bbde-c5a270e64df6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "01a188eb-fdcb-76d8-bbde-c5a270e64df6",
        "storage_key": "property/6767906449167581/01a188eb-fdcb-76d8-bbde-c5a270e64df6.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, stainless steel appliances including a microwave and refrigerator, and a large granite island with seating.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-kitchen(2).jpg"
    },
    {
      "id": "ec_c679abd8b9c6430e362f1c96",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188ec-0128-71bc-92e9-ffbc66029e11.webp",
      "image_media": {
        "alt_text": "Aerial view of a waterfront community with homes, trees, and a lake.",
        "public_id": "01a188ec-0128-71bc-92e9-ffbc66029e11",
        "storage_key": "property/6767906449167581/01a188ec-0128-71bc-92e9-ffbc66029e11.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Experience luxurious waterfront living in this beautiful community, featuring stunning homes nestled beside a serene lake and surrounded by lush greenery.",
      "link": "false",
      "alt_text": "A bird's eye view of a residential area with houses surrounded by water and greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/bluffton-4.jpg"
    },
    {
      "id": "ec_6236b324f45e3a60a7c7a235",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188ec-058d-700d-a786-1279934c2751.webp",
      "image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures.",
        "public_id": "01a188ec-058d-700d-a786-1279934c2751",
        "storage_key": "property/6767906449167581/01a188ec-058d-700d-a786-1279934c2751.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Enjoy the community's state-of-the-art playground, perfect for family fun and outdoor recreation.",
      "link": "false",
      "alt_text": "A playground with a blue slide and a green fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/bluffton-3.jpg"
    },
    {
      "id": "ec_17afb19a5ac7b925a4989f21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188eb-e324-731d-8a21-23e595536a5c.webp",
      "image_media": {
        "alt_text": "Exterior of a white townhouse with a garage, front door, and manicured landscaping.",
        "public_id": "01a188eb-e324-731d-8a21-23e595536a5c",
        "storage_key": "property/6767906449167581/01a188eb-e324-731d-8a21-23e595536a5c.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "View of the exterior of a charming white townhouse, featuring a spacious garage and an inviting front entrance, surrounded by lush pine trees.",
      "link": "false",
      "alt_text": "A white house with a black door and a garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland.jpg"
    },
    {
      "id": "ec_6929595586178b9af66d659e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188ec-0c86-740b-a86b-b618e95e87ba.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
        "public_id": "01a188ec-0c86-740b-a86b-b618e95e87ba",
        "storage_key": "property/6767906449167581/01a188ec-0c86-740b-a86b-b618e95e87ba.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring sleek white cabinetry, elegant granite countertops, and top-of-the-line stainless steel appliances for a refined cooking experience.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/beaufort-kitchen(1).jpg"
    },
    {
      "id": "ec_905373684aecff5db7ff383b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188ec-0a55-7169-b429-ac91616e508c.webp",
      "image_media": {
        "alt_text": "Aerial view of a new housing development with rows of white houses and dark roofs.",
        "public_id": "01a188ec-0a55-7169-b429-ac91616e508c",
        "storage_key": "property/6767906449167581/01a188ec-0a55-7169-b429-ac91616e508c.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Explore this charming new community featuring beautiful homes with modern designs. Perfect for families looking for a fresh start.",
      "link": "false",
      "alt_text": "A suburban neighborhood with houses and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/community-4.jpg"
    },
    {
      "id": "ec_7e7c0980ba9cfc2f489278a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188ec-0abf-708e-9e63-667aa1f1aefd.webp",
      "image_media": {
        "alt_text": "Living room and kitchen of a modern apartment with a sectional sofa, coffee table, and island.",
        "public_id": "01a188ec-0abf-708e-9e63-667aa1f1aefd",
        "storage_key": "property/6767906449167581/01a188ec-0abf-708e-9e63-667aa1f1aefd.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment featuring an open-concept living and kitchen area, perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "A living room with a couch, a coffee table, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-living(1).jpg"
    },
    {
      "id": "ec_9cb8668dc8c0964dc64d259e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/01a188ec-0e31-7134-8d7f-08e95446948d.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity and bathtub",
        "public_id": "01a188ec-0e31-7134-8d7f-08e95446948d",
        "storage_key": "property/6767906449167581/01a188ec-0e31-7134-8d7f-08e95446948d.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops and a bathtub with shower.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and a door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/beaufort-bath.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_5ecc7578-b393-439b-b62d-6a657b1178bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Southern Barrel Brewing Co.",
      "poi_type": "Restaurants",
      "poi_address": "375 Buckwalter Place Blvd, Bluffton, SC 29910, USA",
      "poi_short_description": "Craft brewery and taproom at Buckwalter Place in Bluffton.",
      "poi_long_description": "Craft brewery and taproom at Buckwalter Place in Bluffton.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-04d0-7001-9cc3-9b88e30fecb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-04d0-7001-9cc3-9b88e30fecb9",
        "storage_key": "property/6767906449167581/019fc85e-04d0-7001-9cc3-9b88e30fecb9.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://southernbarrel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12867378145026041116",
      "poi_item_slug": "southern-barrel-brewing-co",
      "poi_latitude": "32.2714742",
      "poi_longitude": "-80.919917",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-837-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-7056201cee79",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB1brGsKO-4gRHOXmpD8ckrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_6099bad5-443e-4763-aeff-20dac5ea343d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Squat 'N' Gobble",
      "poi_type": "Restaurants",
      "poi_address": "1231 May River Rd, Bluffton, SC 29910, USA",
      "poi_short_description": "Something-for-everyone Southern breakfast/lunch counter with rotating specials & quirky personality.",
      "poi_long_description": "Something-for-everyone Southern breakfast/lunch counter with rotating specials & quirky personality.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-f20c-7703-ab3b-be6c646bf360.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-f20c-7703-ab3b-be6c646bf360",
        "storage_key": "property/6767906449167581/019fc85d-f20c-7703-ab3b-be6c646bf360.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.squatngobble.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1563407492164472622",
      "poi_item_slug": "squat-n-gobble",
      "poi_latitude": "32.237372",
      "poi_longitude": "-80.8686358",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-757-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-74086d2e9f9b",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLQmZ--6I-4gRLs-lsdRWshU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a583cdb6-683f-4fd0-8c40-817b535e5bb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "May River Grill",
      "poi_type": "Restaurants",
      "poi_address": "1263 May River Rd Unit D, Bluffton, SC 29910, USA",
      "poi_short_description": "A varied American menu is served at this easygoing, brightly colored grill with a fish motif.",
      "poi_long_description": "A varied American menu is served at this easygoing, brightly colored grill with a fish motif.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-eefb-726a-9edc-11508f8ec33a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-eefb-726a-9edc-11508f8ec33a",
        "storage_key": "property/6767906449167581/019fc85d-eefb-726a-9edc-11508f8ec33a.webp",
        "width": 720,
        "height": 518
      },
      "poi_business_url": "https://www.mayrivergrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5633936566946178928",
      "poi_item_slug": "may-river-grill",
      "poi_latitude": "32.2375553",
      "poi_longitude": "-80.86552910000002",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-757-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-74086d2e9f9b",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZTu1O-I-4gRcCfpL3XDL04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_261bd883-726d-4b3d-856e-ff1da5c1e42b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "FARM Bluffton",
      "poi_type": "Restaurants",
      "poi_address": "1301 May River Rd, Bluffton, SC 29910, USA",
      "poi_short_description": "Rustic-chic pick for seasonal Southern fare with wine & craft cocktails in snug, bustling digs.",
      "poi_long_description": "Rustic-chic pick for seasonal Southern fare with wine & craft cocktails in snug, bustling digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-e153-72da-960c-75aff77f5c67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-e153-72da-960c-75aff77f5c67",
        "storage_key": "property/6767906449167581/019fc85d-e153-72da-960c-75aff77f5c67.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://farmbluffton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6276263231548101845",
      "poi_item_slug": "farm-bluffton",
      "poi_latitude": "32.237382",
      "poi_longitude": "-80.8615842",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-707-2041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-74086d2e9f9b",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1a4gHvGI-4gR1RRF8SfEGVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0d7189ad-352f-44c9-959b-aefd09d74af4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Corner Perk Brunch Cafe & Coffee Roasters - Bluffton",
      "poi_type": "Restaurants",
      "poi_address": "1297 May River Rd, Bluffton, SC 29910, USA",
      "poi_short_description": "Stylish coffee shop offering espresso drinks made from house beans, plus tea & smoothies.",
      "poi_long_description": "Stylish coffee shop offering espresso drinks made from house beans, plus tea & smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-ebe0-735d-9521-29839de09331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-ebe0-735d-9521-29839de09331",
        "storage_key": "property/6767906449167581/019fc85d-ebe0-735d-9521-29839de09331.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cornerperk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=94617041374813557",
      "poi_item_slug": "corner-perk-brunch-cafe--coffee-roasters---bluffton",
      "poi_latitude": "32.2374111",
      "poi_longitude": "-80.86184569999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-816-5674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-424a-76da-a31e-5c801a97a243.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85e-424a-76da-a31e-5c801a97a243",
        "storage_key": "property/6767906449167581/019fc85e-424a-76da-a31e-5c801a97a243.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJmY_jY1eI-4gRdR3YpLIlUAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_90c58e05-d237-40b8-9967-e013a2b30c6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "The Pearl Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "55 Calhoun St, Bluffton, SC 29910, USA",
      "poi_short_description": "Casual restaurant & bar offering coastal seafood dishes & grilled fare, with front porch seating.",
      "poi_long_description": "Casual restaurant & bar offering coastal seafood dishes & grilled fare, with front porch seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-eb7e-7338-a36f-e9970c8fab6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-eb7e-7338-a36f-e9970c8fab6c",
        "storage_key": "property/6767906449167581/019fc85d-eb7e-7338-a36f-e9970c8fab6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thepearlbluffton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=532826016119153407",
      "poi_item_slug": "the-pearl-kitchen--bar",
      "poi_latitude": "32.2343338",
      "poi_longitude": "-80.8624495",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-757-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-74086d2e9f9b",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1Sz1fOI-4gR_2LeSXD6ZAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ed185dbe-76a6-462a-a7b1-7255390dbd33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "The Bluffton Room",
      "poi_type": "Restaurants",
      "poi_address": "15 Promenade St, Bluffton, SC 29910, USA",
      "poi_short_description": "Inspired American cuisine & cocktails in a modern, rustic setting with open-air bar & patio.",
      "poi_long_description": "Inspired American cuisine & cocktails in a modern, rustic setting with open-air bar & patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-e672-77b4-830f-b94cb9cae462.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-e672-77b4-830f-b94cb9cae462",
        "storage_key": "property/6767906449167581/019fc85d-e672-77b4-830f-b94cb9cae462.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.theblufftonroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=803259808877592039",
      "poi_item_slug": "the-bluffton-room",
      "poi_latitude": "32.2388418",
      "poi_longitude": "-80.8618152",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-757-3525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-74086d2e9f9b",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrQBw7vCI-4gR5z1_UorAJQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_60dd8c15-b36b-491c-9415-498fc37139f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Local Pie Bluffton",
      "poi_type": "Restaurants",
      "poi_address": "15 State Of Mind St, Bluffton, SC 29910, USA",
      "poi_short_description": "Bricks-baked pizza and pies dished at this relaxed joint with a patio, beer and other drinks served.",
      "poi_long_description": "Bricks-baked pizza and pies dished at this relaxed joint with a patio, beer and other drinks served.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-e0ee-70cd-bc96-f1c645fe4636.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-e0ee-70cd-bc96-f1c645fe4636",
        "storage_key": "property/6767906449167581/019fc85d-e0ee-70cd-bc96-f1c645fe4636.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://localpie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13119565959222494302",
      "poi_item_slug": "local-pie-bluffton",
      "poi_latitude": "32.2383828",
      "poi_longitude": "-80.8614992",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-837-7437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-74086d2e9f9b",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6pq6_CI-4gRXoTDvroPErY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_145c0cfb-9249-4248-8a3b-4d604f13dd2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Captain Woody's Seafood Bar",
      "poi_type": "Restaurants",
      "poi_address": "17 State Of Mind St, Bluffton, SC 29910, USA",
      "poi_short_description": "Familiar meat & seafood dishes in a vibrant restaurant with outdoor tables & nautical accents.",
      "poi_long_description": "Familiar meat & seafood dishes in a vibrant restaurant with outdoor tables & nautical accents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-eb7d-74db-8369-82b392f89a2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-eb7d-74db-8369-82b392f89a2f",
        "storage_key": "property/6767906449167581/019fc85d-eb7d-74db-8369-82b392f89a2f.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://bluffton.captainwoodys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11143508847117021640",
      "poi_item_slug": "captain-woodys-seafood-bar",
      "poi_latitude": "32.238441",
      "poi_longitude": "-80.861655",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-757-6222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-74086d2e9f9b",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVyXaKfGI-4gRyDHVb0GypZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_ef1f4e5e-de0e-4408-90cc-1430d9397f37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Bluffton Barbeque",
      "poi_type": "Restaurants",
      "poi_address": "11 State Of Mind St, Bluffton, SC 29910, USA",
      "poi_short_description": "Charming counter-serve eatery dishing up slow-cooked BBQ & homestyle sides in quaint, rustic digs.",
      "poi_long_description": "Charming counter-serve eatery dishing up slow-cooked BBQ & homestyle sides in quaint, rustic digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-e6cf-72af-a808-6bf22f905b9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-e6cf-72af-a808-6bf22f905b9f",
        "storage_key": "property/6767906449167581/019fc85d-e6cf-72af-a808-6bf22f905b9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://destination-bbq.com/stores/blufton-bbq/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17760255575957695040",
      "poi_item_slug": "bluffton-barbeque",
      "poi_latitude": "32.2383409",
      "poi_longitude": "-80.861065",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-757-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-74086d2e9f9b",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-74086d2e9f9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqXEryfCI-4gRQOobNVkaefY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_5cd3dc09-511e-4515-a4fd-fbdbe1d532c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Lowcountry Fresh Market & Cafe",
      "poi_type": "Shopping & Retail",
      "poi_address": "303 Bleecker St S, Bluffton, SC 29910, USA",
      "poi_short_description": "Market offering locally sourced meats and seafood, a deli, a bakery, and a cafe with a porch.",
      "poi_long_description": "Market offering locally sourced meats and seafood, a deli, a bakery, and a cafe with a porch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-4877-72a4-9d05-eff06cd067cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85b-4877-72a4-9d05-eff06cd067cf",
        "storage_key": "property/6767906449167581/019fc85b-4877-72a4-9d05-eff06cd067cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lowcountryfresh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10011382899027741330",
      "poi_item_slug": "lowcountry-fresh-market--cafe",
      "poi_latitude": "32.2780656",
      "poi_longitude": "-80.9140025",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-815-2780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70b0-7392-a430-2d85f44368d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70b0-7392-a430-2d85f44368d8",
        "storage_key": "property/6767906449167581/019fc85b-70b0-7392-a430-2d85f44368d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSgXdcSP-4gRkgr4PrST74o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_aee7a50e-db6e-4459-892c-e0f76725d8ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Bluffton Oyster Co",
      "poi_type": "Shopping & Retail",
      "poi_address": "63 Wharf St, Bluffton, SC 29910, USA",
      "poi_short_description": "Oceanside, mellow eatery & retailer offering a large variety of fried seafood, sandwiches & more.",
      "poi_long_description": "Oceanside, mellow eatery & retailer offering a large variety of fried seafood, sandwiches & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-ed18-7648-b272-8e17ed0dab48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-ed18-7648-b272-8e17ed0dab48",
        "storage_key": "property/6767906449167581/019fc85d-ed18-7648-b272-8e17ed0dab48.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://blufftonoyster.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1029348702066047552",
      "poi_item_slug": "bluffton-oyster-co",
      "poi_latitude": "32.2316667",
      "poi_longitude": "-80.8672222",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-757-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-424d-771d-9cf2-166e9bec9535.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85e-424d-771d-9cf2-166e9bec9535",
        "storage_key": "property/6767906449167581/019fc85e-424d-771d-9cf2-166e9bec9535.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-9qpou2I-4gRQPqn2DD7SA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_c331f682-7d86-4481-9057-7d8270d0ec2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Publix Super Market at Bluffton Commons at Belfair",
      "poi_type": "Shopping & Retail",
      "poi_address": "80 Baylor Dr, Bluffton, SC 29910, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-f39f-733b-a070-a70344fdb4a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-f39f-733b-a070-a70344fdb4a1",
        "storage_key": "property/6767906449167581/019fc85d-f39f-733b-a070-a70344fdb4a1.webp",
        "width": 1145,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=845&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=15986671893971811578",
      "poi_item_slug": "publix-super-market-at-bluffton-commons-at-belfair",
      "poi_latitude": "32.2777342",
      "poi_longitude": "-80.8771889",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-706-3049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70b0-7392-a430-2d85f44368d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70b0-7392-a430-2d85f44368d8",
        "storage_key": "property/6767906449167581/019fc85b-70b0-7392-a430-2d85f44368d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2UTuwkGJ-4gR-jzp9GIR3N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_213ec8f4-6eda-49f8-beb0-eefebd5202c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "125 Towne Dr, Bluffton, SC 29910, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-f2d7-70ae-b228-0eafb171a208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-f2d7-70ae-b228-0eafb171a208",
        "storage_key": "property/6767906449167581/019fc85d-f2d7-70ae-b228-0eafb171a208.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/sc/bluffton/belfair-towne-village/011/00499?cid=loc_01100499_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12804546669815285159",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.2681702",
      "poi_longitude": "-80.8582565",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-815-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70b0-7392-a430-2d85f44368d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70b0-7392-a430-2d85f44368d8",
        "storage_key": "property/6767906449167581/019fc85b-70b0-7392-a430-2d85f44368d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QCi5QuJ-4gRp0VA1FrjsrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_00457897-53fc-42f6-a9a0-89fbd5587732",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4 Bluffton Rd, Bluffton, SC 29910, USA",
      "poi_short_description": "Vast chain retailer selling groceries and household goods alongside clothing and electronics.",
      "poi_long_description": "Vast chain retailer selling groceries and household goods alongside clothing and electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-f81f-705d-976a-26e5d0615a38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-f81f-705d-976a-26e5d0615a38",
        "storage_key": "property/6767906449167581/019fc85d-f81f-705d-976a-26e5d0615a38.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/6395-bluffton-sc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14173360035024346337",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.2595334",
      "poi_longitude": "-80.8544162",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-815-5159",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-424d-771d-9cf2-166e9bec9535.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85e-424d-771d-9cf2-166e9bec9535",
        "storage_key": "property/6767906449167581/019fc85e-424d-771d-9cf2-166e9bec9535.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi9G3NKiJ-4gR4RxYsdvjscQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_09d0e650-5f83-4b70-855d-df91dca65ccf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Tanger Outlets Hilton Head 2",
      "poi_type": "Shopping & Retail",
      "poi_address": "1414 Fording Island Rd, Bluffton, SC 29910, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-f910-77ac-a29a-0ed9350ea703.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-f910-77ac-a29a-0ed9350ea703",
        "storage_key": "property/6767906449167581/019fc85d-f910-77ac-a29a-0ed9350ea703.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tangeroutlet.com/hiltonhead",
      "poi_directions_map_url": "https://maps.google.com/?cid=13830986477531317451",
      "poi_item_slug": "tanger-outlets-hilton-head-2",
      "poi_latitude": "32.239574",
      "poi_longitude": "-80.8201393",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 843-837-5410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-424d-771d-9cf2-166e9bec9535.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85e-424d-771d-9cf2-166e9bec9535",
        "storage_key": "property/6767906449167581/019fc85e-424d-771d-9cf2-166e9bec9535.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl9tNyC-I-4gRy0R87uuI8b8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_162b4d37-a43c-43e1-8f6a-7ecd4460a9f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "MUSC Health Bluffton",
      "poi_type": "Health and Wellness",
      "poi_address": "7000 Buckwalter Towne Blvd, Bluffton, SC 29910, USA",
      "poi_short_description": "MUSC Health medical center on Buckwalter Towne Blvd in Bluffton.",
      "poi_long_description": "MUSC Health medical center on Buckwalter Towne Blvd in Bluffton.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3080499483840757507",
      "poi_item_slug": "musc-health-bluffton",
      "poi_latitude": "32.2687658",
      "poi_longitude": "-80.9139799",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70ba-74de-b773-14e0f74debf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70ba-74de-b773-14e0f74debf3",
        "storage_key": "property/6767906449167581/019fc85b-70ba-74de-b773-14e0f74debf3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKwimJACP-4gRAz8amfUhwCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_bde89ba6-82b7-48b3-9d5c-1d5888055c7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "St. Joseph's/Candler Urgent Care - Bluffton",
      "poi_type": "Health and Wellness",
      "poi_address": "3 Progressive St, Bluffton, SC 29910, USA",
      "poi_short_description": "Walk-in urgent care clinic operated by St. Joseph's/Candler, Bluffton.",
      "poi_long_description": "Walk-in urgent care clinic operated by St. Joseph's/Candler, Bluffton.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-0f58-70d6-9751-abb1c02f24f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-0f58-70d6-9751-abb1c02f24f4",
        "storage_key": "property/6767906449167581/019fc85e-0f58-70d6-9751-abb1c02f24f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sjcurgentcare.com/locations/bluffton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=63310510458021446",
      "poi_item_slug": "st-josephscandler-urgent-care---bluffton",
      "poi_latitude": "32.2732593",
      "poi_longitude": "-80.91514029999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-548-0533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-7056201cee79",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVyXaKfGI-4gRRiZm5pLs4AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_df06614a-b388-4729-adb2-a08d5ed60997",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "868 Fording Island Rd, Bluffton, SC 29910, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-f822-7016-b138-ed51ba41fb80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-f822-7016-b138-ed51ba41fb80",
        "storage_key": "property/6767906449167581/019fc85d-f822-7016-b138-ed51ba41fb80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-868+fording+island+rd-bluffton-sc-29910/id=7652",
      "poi_directions_map_url": "https://maps.google.com/?cid=12647324579335157404",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.2670677",
      "poi_longitude": "-80.861097",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-815-9953",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-7056201cee79",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Uy8sQ6J-4gRnLZWTrJShK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_64c19198-eaf2-4bbb-ab7b-74b4adcf9c4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "50 Burnt Church Rd #100f, Bluffton, SC 29910, USA",
      "poi_short_description": "Chain gym offering tanning and massage chairs, as well as a friendly staff.",
      "poi_long_description": "Chain gym offering tanning and massage chairs, as well as a friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-10f1-7758-bd33-d178ae7ec5d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-10f1-7758-bd33-d178ae7ec5d9",
        "storage_key": "property/6767906449167581/019fc85e-10f1-7758-bd33-d178ae7ec5d9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/bluffton-sc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11086020160210563259",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.2483448",
      "poi_longitude": "-80.8456684",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-380-9510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-7056201cee79",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNW1D0HuJ-4gRu3Ardpl02Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9d690ae3-f5a2-4683-abfc-cc15a12773eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Novant Health Coastal Carolina Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 Medical Center Dr, Hardeeville, SC 29927, USA",
      "poi_short_description": "General hospital with an emergency department in Hardeeville, the closest hospital to New Riverside.",
      "poi_long_description": "General hospital with an emergency department in Hardeeville, the closest hospital to New Riverside.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-25ca-752b-aea6-64a05d19c8c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-25ca-752b-aea6-64a05d19c8c1",
        "storage_key": "property/6767906449167581/019fc85e-25ca-752b-aea6-64a05d19c8c1.webp",
        "width": 1243,
        "height": 1280
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/coastal-carolina-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GMB&utm_content=MC-26&ecid=gmblocamc26",
      "poi_directions_map_url": "https://maps.google.com/?cid=3821209847800649246",
      "poi_item_slug": "novant-health-coastal-carolina-medical-center",
      "poi_latitude": "32.3152138",
      "poi_longitude": "-81.0539155",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-784-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70ba-74de-b773-14e0f74debf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70ba-74de-b773-14e0f74debf3",
        "storage_key": "property/6767906449167581/019fc85b-70ba-74de-b773-14e0f74debf3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59tsQeaT-4gRHtZhZhyqBzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_e968c191-588e-44a1-8c3c-8431a706ca08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Palmetto Breeze Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "25 Benton Fld Rd, Bluffton, SC 29910, USA",
      "poi_short_description": "Lowcountry regional public bus service serving Bluffton, Hilton Head and Beaufort County.",
      "poi_long_description": "Lowcountry regional public bus service serving Bluffton, Hilton Head and Beaufort County.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-2128-712f-a3c3-be2fe88dd56a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-2128-712f-a3c3-be2fe88dd56a",
        "storage_key": "property/6767906449167581/019fc85e-2128-712f-a3c3-be2fe88dd56a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.palmettobreezetransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16061171847067150890",
      "poi_item_slug": "palmetto-breeze-transit",
      "poi_latitude": "32.2298928",
      "poi_longitude": "-80.8513783",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-757-5782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-7056201cee79",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6qeul-I-4gRKirx_LK-5N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_b703b5d5-afd8-4e85-bdc6-c90913eff192",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Hilton Head Island Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "120 Beach City Rd, Hilton Head Island, SC 29926, USA",
      "poi_short_description": "Regional commercial airport on Hilton Head Island.",
      "poi_long_description": "Regional commercial airport on Hilton Head Island.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-1f6c-75fa-82a8-848e00f368e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-1f6c-75fa-82a8-848e00f368e4",
        "storage_key": "property/6767906449167581/019fc85e-1f6c-75fa-82a8-848e00f368e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hiltonheadairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3994055299393922678",
      "poi_item_slug": "hilton-head-island-airport",
      "poi_latitude": "32.2248476",
      "poi_longitude": "-80.6971648",
      "poi_miles_from_property": "19.7 mi",
      "poi_walking_minutes": "7 hours 8 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 843-842-7728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-44d2-746b-82fe-2e841f7c85d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85e-44d2-746b-82fe-2e841f7c85d9",
        "storage_key": "property/6767906449167581/019fc85e-44d2-746b-82fe-2e841f7c85d9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzVZuulw_IgRdiakJSK8bTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8b260016-adc1-4772-9348-16e899178aee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "The Zone",
      "poi_type": "Entertainment",
      "poi_address": "108 Buckwalter Pkwy Ste 2F, Bluffton, SC 29910, USA",
      "poi_short_description": "Fun center offering a variety of pursuits from mini golf to batting cages to laser tag and more, plus a snack bar.",
      "poi_long_description": "Fun center offering a variety of pursuits from mini golf to batting cages to laser tag and more, plus a snack bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-01b7-7637-a642-d4bd0c1bf414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-01b7-7637-a642-d4bd0c1bf414",
        "storage_key": "property/6767906449167581/019fc85e-01b7-7637-a642-d4bd0c1bf414.webp",
        "width": 1280,
        "height": 681
      },
      "poi_business_url": "https://thezonebluffton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8976537474570191202",
      "poi_item_slug": "the-zone",
      "poi_latitude": "32.2833774",
      "poi_longitude": "-80.9121309",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-836-3701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-7056201cee79",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA9orYnCP-4gRYgG9_EURk3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_a76bd791-35d4-4b33-9551-7baefa8bcb77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Cinemark Bluffton",
      "poi_type": "Entertainment",
      "poi_address": "106 Buckwalter Pkwy, Bluffton, SC 29910, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-053d-7387-aa8d-065d681a7b12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-053d-7387-aa8d-065d681a7b12",
        "storage_key": "property/6767906449167581/019fc85e-053d-7387-aa8d-065d681a7b12.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "https://www.cinemark.com/theatres/sc-bluffton/cinemark-bluffton?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTMwNTgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5515406982863571990",
      "poi_item_slug": "cinemark-bluffton",
      "poi_latitude": "32.2837081",
      "poi_longitude": "-80.9126582",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-757-2859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-423f-71a8-9cfc-c085011ae101.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85e-423f-71a8-9cfc-c085011ae101",
        "storage_key": "property/6767906449167581/019fc85e-423f-71a8-9cfc-c085011ae101.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82RsGrqO-4gRFsxK1W2pikw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_02801f39-9377-4e3c-95d3-48e94bd3315f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Heyward House Museum and Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "70 Boundary St, Bluffton, SC 29910, USA",
      "poi_short_description": "1841 historic home offering guided tours & artifacts that describe life in the antebellum South.",
      "poi_long_description": "1841 historic home offering guided tours & artifacts that describe life in the antebellum South.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-0215-73fd-b1e6-22bbf3e753e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-0215-73fd-b1e6-22bbf3e753e1",
        "storage_key": "property/6767906449167581/019fc85e-0215-73fd-b1e6-22bbf3e753e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://historicbluffton.org/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17013911750672552812",
      "poi_item_slug": "heyward-house-museum-and-cultural-center",
      "poi_latitude": "32.2331734",
      "poi_longitude": "-80.86179349999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-757-6293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-428c-74fd-9227-1c7913f9f2cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85e-428c-74fd-9227-1c7913f9f2cc",
        "storage_key": "property/6767906449167581/019fc85e-428c-74fd-9227-1c7913f9f2cc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-cvwvOI-4gRbJOu-peOHew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6f8ce22e-1e97-4b97-ba61-05a5e98ecd5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Arts Center of Coastal Carolina",
      "poi_type": "Entertainment",
      "poi_address": "14 Shelter Cove Ln, Hilton Head Island, SC 29928, USA",
      "poi_short_description": "Multipart venue hosting drama, comedy, musical & experimental theater, plus a visual-arts gallery.",
      "poi_long_description": "Multipart venue hosting drama, comedy, musical & experimental theater, plus a visual-arts gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-0cc0-73fc-b867-5109dbec5f2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-0cc0-73fc-b867-5109dbec5f2d",
        "storage_key": "property/6767906449167581/019fc85e-0cc0-73fc-b867-5109dbec5f2d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.artshhi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16909744288248500100",
      "poi_item_slug": "arts-center-of-coastal-carolina",
      "poi_latitude": "32.1783161",
      "poi_longitude": "-80.72817409999999",
      "poi_miles_from_property": "21.9 mi",
      "poi_walking_minutes": "7 hours 57 mins",
      "poi_biking_minutes": "2 hours 4 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 843-842-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-7056201cee79",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0xXVvF5_IgRhA--p9Z6q-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0a0f8e95-27bc-448a-a6ca-32841256ff8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "May River High School",
      "poi_type": "Education",
      "poi_address": "601 New Riverside Rd, Bluffton, SC 29910, USA",
      "poi_short_description": "Public high school, Beaufort County School District.",
      "poi_long_description": "Public high school, Beaufort County School District.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-fbd2-7518-8b04-e7bc68a9d2e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-fbd2-7518-8b04-e7bc68a9d2e1",
        "storage_key": "property/6767906449167581/019fc85d-fbd2-7518-8b04-e7bc68a9d2e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://mrhs.beaufortschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5476279162582781549",
      "poi_item_slug": "may-river-high-school",
      "poi_latitude": "32.2165569",
      "poi_longitude": "-80.97200060000002",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-836-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4cuzAvSP-4gRbc6eQOKm_0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_337ba3f4-4717-4593-81a8-a7fe318575d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Bluffton High School",
      "poi_type": "Education",
      "poi_address": "12 H. E. McCracken Cir, Bluffton, SC 29910, USA",
      "poi_short_description": "Public high school, Beaufort County School District.",
      "poi_long_description": "Public high school, Beaufort County School District.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-fe30-707d-ac23-6bb580c1f585.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-fe30-707d-ac23-6bb580c1f585",
        "storage_key": "property/6767906449167581/019fc85d-fe30-707d-ac23-6bb580c1f585.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "http://blhs.beaufortschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11036378063369519386",
      "poi_item_slug": "bluffton-high-school",
      "poi_latitude": "32.2514716",
      "poi_longitude": "-80.8988785",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-706-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4c2AjCqP-4gRGsENGmAXKZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8f06af15-ddd8-4307-9dd7-8229361f6387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Bluffton Elementary School",
      "poi_type": "Education",
      "poi_address": "160 H. E. McCracken Cir, Bluffton, SC 29910, USA",
      "poi_short_description": "Public elementary school, Beaufort County School District.",
      "poi_long_description": "Public elementary school, Beaufort County School District.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://bles.beaufortschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9712326918354884840",
      "poi_item_slug": "bluffton-elementary-school",
      "poi_latitude": "32.2472994",
      "poi_longitude": "-80.8983497",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-706-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8WmzF9OI-4gR6NgBx98dyYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3b752ee5-594d-4340-96e8-ab7b179a8984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Bluffton Middle School",
      "poi_type": "Education",
      "poi_address": "30 New Mustang Dr, Bluffton, SC 29910, USA",
      "poi_short_description": "Public middle school, Beaufort County School District.",
      "poi_long_description": "Public middle school, Beaufort County School District.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-fb93-7185-a38a-d14c76dfedad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-fb93-7185-a38a-d14c76dfedad",
        "storage_key": "property/6767906449167581/019fc85d-fb93-7185-a38a-d14c76dfedad.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://blms.beaufortschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10042520684328366586",
      "poi_item_slug": "bluffton-middle-school",
      "poi_latitude": "32.2543411",
      "poi_longitude": "-80.8776779",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-707-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ63DXrWx3_IgR-rHn1lozXos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_056704e9-ad12-42d2-8f43-895ae05635dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Hilton Head Christian Academy",
      "poi_type": "Education",
      "poi_address": "3088 Bluffton Parkway, Bluffton, SC 29910, USA",
      "poi_short_description": "Private Christian school on Bluffton Parkway.",
      "poi_long_description": "Private Christian school on Bluffton Parkway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-0105-7383-8e64-8f5728f20d95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-0105-7383-8e64-8f5728f20d95",
        "storage_key": "property/6767906449167581/019fc85e-0105-7383-8e64-8f5728f20d95.webp",
        "width": 1280,
        "height": 616
      },
      "poi_business_url": "http://www.hhca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8704954288963600150",
      "poi_item_slug": "hilton-head-christian-academy",
      "poi_latitude": "32.2566339",
      "poi_longitude": "-80.89879859999999",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-681-2878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbeqdP7dw_IgRFj-wE841zng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_be3a3306-3543-4bfe-9a06-173d97d3e105",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "St. Gregory the Great Catholic School",
      "poi_type": "Education",
      "poi_address": "38 St Gregory Dr, Bluffton, SC 29909, USA",
      "poi_short_description": "Private Catholic school in Bluffton.",
      "poi_long_description": "Private Catholic school in Bluffton.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-ffb6-76f2-b9e4-ec5ff2a58600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85d-ffb6-76f2-b9e4-ec5ff2a58600",
        "storage_key": "property/6767906449167581/019fc85d-ffb6-76f2-b9e4-ec5ff2a58600.webp",
        "width": 680,
        "height": 1000
      },
      "poi_business_url": "https://www.sggcs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17285687825784611175",
      "poi_item_slug": "st-gregory-the-great-catholic-school",
      "poi_latitude": "32.2929586",
      "poi_longitude": "-80.90578049999999",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-815-9988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9QTNDKWO-4gRZ6Even4Z4-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3f13d46a-1599-47e3-8b49-97f13dd16459",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "University of South Carolina Beaufort - Bluffton campus",
      "poi_type": "Education",
      "poi_address": "1 University Blvd, Bluffton, SC 29909, USA",
      "poi_short_description": "University of South Carolina Beaufort's Bluffton campus.",
      "poi_long_description": "University of South Carolina Beaufort's Bluffton campus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-50a9-76f0-ad16-dd25f59ea665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85b-50a9-76f0-ad16-dd25f59ea665",
        "storage_key": "property/6767906449167581/019fc85b-50a9-76f0-ad16-dd25f59ea665.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "https://www.uscb.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3640289083893344222",
      "poi_item_slug": "university-of-south-carolina-beaufort---bluffton-campus",
      "poi_latitude": "32.3032706",
      "poi_longitude": "-80.9735548",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-208-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN-9J8rYN_IgR3ucxfaLnhDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_77f83e00-8a54-437a-ab21-78a44b9e39b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Technical College of the Lowcountry",
      "poi_type": "Education",
      "poi_address": "100 Community College Dr, Okatie, SC 29909, USA",
      "poi_short_description": "Public technical college, New River campus in Okatie.",
      "poi_long_description": "Public technical college, New River campus in Okatie.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-2860-7491-a1a3-9584de1c9c5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-2860-7491-a1a3-9584de1c9c5b",
        "storage_key": "property/6767906449167581/019fc85e-2860-7491-a1a3-9584de1c9c5b.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.tcl.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14111499849605740133",
      "poi_item_slug": "technical-college-of-the-lowcountry",
      "poi_latitude": "32.30297",
      "poi_longitude": "-80.96541549999999",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-470-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjdSwxwqO-4gRZXa651ge1sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f07f94c4-507d-45e3-b4e7-815be02176e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Little Steps Daycare Preschool",
      "poi_type": "Education",
      "poi_address": "18 Oak Forest Rd Ste C, Bluffton, SC 29910, USA",
      "poi_short_description": "Daycare and preschool in Bluffton.",
      "poi_long_description": "Daycare and preschool in Bluffton.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-0211-7068-bb05-56a80668eb30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-0211-7068-bb05-56a80668eb30",
        "storage_key": "property/6767906449167581/019fc85e-0211-7068-bb05-56a80668eb30.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.littlestepsblufftonsc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3015686177346908502",
      "poi_item_slug": "little-steps-daycare-preschool",
      "poi_latitude": "32.2672363",
      "poi_longitude": "-80.85700229999999",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-815-3276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-b779e9de28ec",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-b779e9de28ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSeeee1CJ-4gRVnHRupne2Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_f181c75e-fb68-4a68-843a-f291369362ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Sun City Hilton Head Community Association",
      "poi_type": "Major Employers & Offices",
      "poi_address": "127 Sun City Ln, Bluffton, SC 29909, USA",
      "poi_short_description": "Community association office for the Sun City Hilton Head active-adult community in Okatie.",
      "poi_long_description": "Community association office for the Sun City Hilton Head active-adult community in Okatie.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-2936-77be-a294-8b72d1de0552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-2936-77be-a294-8b72d1de0552",
        "storage_key": "property/6767906449167581/019fc85e-2936-77be-a294-8b72d1de0552.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.suncityhiltonhead.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11918231748026501971",
      "poi_item_slug": "sun-city-hilton-head-community-association",
      "poi_latitude": "32.2906744",
      "poi_longitude": "-80.9505206",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-705-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7098-7492-9cd4-7056201cee79",
        "storage_key": "property/6767906449167581/019fc85b-7098-7492-9cd4-7056201cee79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPzoasXqO-4gRUwvnG6EQZqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_9363bb86-c6c9-49bd-b39d-1ee2610d74f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Bluffton Town Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20 Bridge St, Bluffton, SC 29910, USA",
      "poi_short_description": "Town of Bluffton municipal offices.",
      "poi_long_description": "Town of Bluffton municipal offices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-26cd-71ce-bbab-f7022e607f62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-26cd-71ce-bbab-f7022e607f62",
        "storage_key": "property/6767906449167581/019fc85e-26cd-71ce-bbab-f7022e607f62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.townofbluffton.sc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12285213089506753378",
      "poi_item_slug": "bluffton-town-hall",
      "poi_latitude": "32.2322939",
      "poi_longitude": "-80.8587943",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-706-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7322-769e-a421-5f9e423b6693.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7322-769e-a421-5f9e423b6693",
        "storage_key": "property/6767906449167581/019fc85b-7322-769e-a421-5f9e423b6693.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSM9e_SI-4gRYnsHDjfYfao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_04b9db42-e709-42df-bd69-ff090f020c16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Beaufort County Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4819 Bluffton Parkway #1, Bluffton, SC 29910, USA",
      "poi_short_description": "Beaufort County government offices on Bluffton Parkway.",
      "poi_long_description": "Beaufort County government offices on Bluffton Parkway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-23b3-7792-b0c4-5f92b7547fa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-23b3-7792-b0c4-5f92b7547fa4",
        "storage_key": "property/6767906449167581/019fc85e-23b3-7792-b0c4-5f92b7547fa4.webp",
        "width": 1280,
        "height": 644
      },
      "poi_business_url": "http://www.beaufortcountysc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1063267506620318065",
      "poi_item_slug": "beaufort-county-offices",
      "poi_latitude": "32.2497787",
      "poi_longitude": "-80.853302",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-255-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7322-769e-a421-5f9e423b6693.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7322-769e-a421-5f9e423b6693",
        "storage_key": "property/6767906449167581/019fc85b-7322-769e-a421-5f9e423b6693.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtd4xFgaJ-4gRccFR8Sl8wQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_9d198988-a65f-459f-8cea-fdb820063e43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "New Riverside Barn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "30 Red Barn Dr, Bluffton, SC 29910, USA",
      "poi_short_description": "Town of Bluffton park at the historic New Riverside Barn, half a mile from the community.",
      "poi_long_description": "Town of Bluffton park at the historic New Riverside Barn, half a mile from the community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-61c8-7535-851c-218b82552c31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85b-61c8-7535-851c-218b82552c31",
        "storage_key": "property/6767906449167581/019fc85b-61c8-7535-851c-218b82552c31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13860813166233143415",
      "poi_item_slug": "new-riverside-barn-park",
      "poi_latitude": "32.2412355",
      "poi_longitude": "-80.9847465",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70c6-7305-9042-3a8c3212f664",
        "storage_key": "property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXZWfwCP-4gRd0hiDyOAW8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_076f3a3e-8cdc-4496-aa32-1711f8cf9310",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "New River Linear Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3809-3835 Okatie Hwy, Bluffton, SC 29910, USA",
      "poi_short_description": "Set in a historic area, this flat trail runs next to a railroad bed & is used for hiking & biking.",
      "poi_long_description": "Set in a historic area, this flat trail runs next to a railroad bed & is used for hiking & biking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-61ea-763e-8c1e-866e058751d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85b-61ea-763e-8c1e-866e058751d1",
        "storage_key": "property/6767906449167581/019fc85b-61ea-763e-8c1e-866e058751d1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.townofbluffton.sc.gov/Facilities/Facility/Details/New-River-Linear-Trail-4",
      "poi_directions_map_url": "https://maps.google.com/?cid=18337864405813466200",
      "poi_item_slug": "new-river-linear-trail",
      "poi_latitude": "32.24165",
      "poi_longitude": "-81.00397",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 843-706-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-7099-76ff-8575-bb6e57cfd13b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-7099-76ff-8575-bb6e57cfd13b",
        "storage_key": "property/6767906449167581/019fc85b-7099-76ff-8575-bb6e57cfd13b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTRaRfj6Q-4gRWJTK14Quff4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_80ce2d35-214a-42e9-b5ed-e8837b42ed2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Bluffton Oyster Factory Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "63 Wharf St, Bluffton, SC 29910, USA",
      "poi_short_description": "This riverfront park with scenic views is a popular gathering place for community events & picnics.",
      "poi_long_description": "This riverfront park with scenic views is a popular gathering place for community events & picnics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-1667-76ef-a9c2-4c6132b1944c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-1667-76ef-a9c2-4c6132b1944c",
        "storage_key": "property/6767906449167581/019fc85e-1667-76ef-a9c2-4c6132b1944c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.townofbluffton.sc.gov/facilities/facility/details/Oyster-Factory-Park-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=14893390883340109643",
      "poi_item_slug": "bluffton-oyster-factory-park",
      "poi_latitude": "32.232687",
      "poi_longitude": "-80.866852",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-757-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70c6-7305-9042-3a8c3212f664",
        "storage_key": "property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtR6pou2I-4gRS0eHjhn0r84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_36a00300-7e12-4a99-bdf2-5d956d33468d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "DuBois Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "67 Lawrence St, Bluffton, SC 29910, USA",
      "poi_short_description": "Easygoing gathering place with a variety of playground equipment, covered picnic areas & shade.",
      "poi_long_description": "Easygoing gathering place with a variety of playground equipment, covered picnic areas & shade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-15fc-7387-b20c-cae592bb806b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-15fc-7387-b20c-cae592bb806b",
        "storage_key": "property/6767906449167581/019fc85e-15fc-7387-b20c-cae592bb806b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.townofbluffton.sc.gov/facilities/facility/details/DuBois-Park-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=12231488344963659678",
      "poi_item_slug": "dubois-park",
      "poi_latitude": "32.2344316",
      "poi_longitude": "-80.8616093",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-706-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70c6-7305-9042-3a8c3212f664",
        "storage_key": "property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWlX3_OI-4gRnrfjM9j5vqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5aa649b8-6a6a-4d15-9d47-4b58a84ea763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Oscar Frazier Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bluffton, SC 29910, USA",
      "poi_short_description": "Large park withs 3 ball fields, a soccer field, playground & tennis courts, plus a community center.",
      "poi_long_description": "Large park withs 3 ball fields, a soccer field, playground & tennis courts, plus a community center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-1be9-7719-96e8-c3c6163dfd03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-1be9-7719-96e8-c3c6163dfd03",
        "storage_key": "property/6767906449167581/019fc85e-1be9-7719-96e8-c3c6163dfd03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bcscrec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17850581016618202392",
      "poi_item_slug": "oscar-frazier-park",
      "poi_latitude": "32.245306",
      "poi_longitude": "-80.86564059999999",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-706-4583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70c6-7305-9042-3a8c3212f664",
        "storage_key": "property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf1MPxOSI-4gRGPXbsdsAuvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fb8aa999-aa5a-46e2-825a-1ab775482088",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "poi_name": "Wright Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Calhoun St, Bluffton, SC 29910, USA",
      "poi_short_description": "Picnic-friendly park featuring swings and a dock, with benches and a playground for kids.",
      "poi_long_description": "Picnic-friendly park featuring swings and a dock, with benches and a playground for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85e-17a8-74bd-93d6-2436a378fcf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc85e-17a8-74bd-93d6-2436a378fcf4",
        "storage_key": "property/6767906449167581/019fc85e-17a8-74bd-93d6-2436a378fcf4.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.townofbluffton.sc.gov/facilities/facility/details/Wright-Family-Park-10",
      "poi_directions_map_url": "https://maps.google.com/?cid=244907809442341384",
      "poi_item_slug": "wright-family-park",
      "poi_latitude": "32.2309176",
      "poi_longitude": "-80.86310750000001",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-540-1662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc85b-70c6-7305-9042-3a8c3212f664",
        "storage_key": "property/6767906449167581/019fc85b-70c6-7305-9042-3a8c3212f664.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQS37NqJ-4gRCKKH6FoWZgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2af720705bd15c8bfdf2ad0a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_8a5abeba076d26e097ca797d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_80e64a9df302231b7b051915",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_d1a24ac6fba9575a5502b0a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_5c5e040838e6889865c707f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_43aba4091dbd2e794415b28f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "rating": "5",
      "name": "Shane Parrish",
      "text": "Can I just say that I have dealt with rental agencies all my life and never have I been treated so kindly and with such professionalism as I have with these wonderful people. And I specifically have to give a huge thank you and express how grateful I am for Gabrielle Dellefave. Gabrielle has been like family to us. Helping us with our daughter and been so kind and understanding. Thank you Gabrielle for making me feel that way. You are amazing!!!",
      "date": "2025-11-21",
      "title": "false"
    },
    {
      "id": "ec_f1751cec8428fab5b8b9636c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "rating": "5",
      "name": "Brite Love",
      "text": "We love our new home. Gabrielle was absolutely wonderful! and made our transition seamless.",
      "date": "2025-12-14",
      "title": "false"
    },
    {
      "id": "ec_b2921cb08b56d4fe34d78cf0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "rating": "5",
      "name": "Shawn Burns",
      "text": "From my first phone encounter with Gabrielle Dellefave, Resident Services Associate, she was outstanding.",
      "date": "2025-11-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_cf9b1116-5149-4f58-9d7c-27fc4663f093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Cumberland home (3 bed, 2.5 bath)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Cumberland",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CfH7ThmtnMm"
    },
    {
      "id": "custom_c2a364c3-47ea-42c4-a8f8-e241d0463dfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Beaufort home (4 bed, 3 bath)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Beaufort",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=McsvEv4friW"
    },
    {
      "id": "custom_6087076b-e7fc-4f73-b8a2-d0aaf7a5f29b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Sapelo home (4 bed, 2.5 bath)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Sapelo",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=V719hqCDTCo"
    }
  ],
  "faqs": [
    {
      "id": "custom_1ce39ccd-0de2-4b97-b159-7e8a74925ce5",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_1a8d6b97-517c-4b38-a1d7-a30ad35a596a",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_bfbb8b0e-063c-4662-bdcd-a621979b833b",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_996c55d9-45d7-4857-9fc0-3c164f18d34a",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_5a2b36af-e790-454a-a286-90b46338b583",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_63961e2d-15c1-4b12-b181-3c5fb425d193",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_8918529f-aeab-4f2f-9198-54c3ffdf69e9",
      "question": "Landscape Services",
      "answer": "Single-family homes: $95/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_41a4bc24-dc03-49e7-96d0-d4dea6e1789f",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_5e3fb73a-c98b-4581-a7a1-306efe53d26f",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_2e2ee45a-8ab3-4cac-8203-ba96b764a89a",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_b2348594-87fb-4480-bc11-557ca77892b8",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_9311b3e8-da52-4441-8ae4-327c44ec85c4",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_0273a28c-12b6-483e-85a7-b7f2c30dccca",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_8ae65542-a427-4d05-ba57-cb1bdefb165b",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_e8a9dd55-c22f-41d3-a830-bace3e4a13bb",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_d8d06181-b955-457d-99a8-31000d8f1af3",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_a0e64082-0773-4cfe-9616-fd4dd112c039",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_66fd2b55-722a-4912-82fe-623902d99297",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_779e883b-5d85-4435-bf51-7b3e57c3582a",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_9e24c98cbe389bcd99aabe9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "yardi",
      "external_id": "2355438",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-9a05-7799-a275-fd1e63806e0a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "New River Forest Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581"
    },
    {
      "lead_collector_id": "01a0abe0-9a89-7618-bf7a-d0241db9b3b0",
      "lead_source": "LANDING_PAGE",
      "name": "New River Forest Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-bluffton-sc",
      "search_query": "in-unit laundry apartments Bluffton SC",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Bliss in Bluffton, SC",
      "h2_subtitle": "Explore in-unit laundry apartments at New River Forest, Bluffton. Experience hassle-free living where convenience meets comfort.",
      "page_copy": "At New River Forest in Bluffton, SC, simplify your daily routine with our in-unit laundry apartments. No more shared laundry rooms or inconvenient trips to the laundromat – enjoy the luxury of doing your laundry in the comfort and privacy of your own home. Located conveniently in Bluffton, our community provides not only this sought-after amenity but also a range of features that elevate your living experience.\n\nBeyond the convenience of in-unit laundry, New River Forest offers a refreshing pool, luxury flooring, and a place for fun at our playground. Spacious closets add to the appeal, and we take care of lawn maintenance so you can truly relax. Choose New River Forest, your perfect destination in Bluffton for hassle-free, comfort-focused living enhanced by the best amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Bluffton, SC",
      "seo_description": "Discover in-unit laundry apartments at New River Forest, Bluffton. Enjoy seamless living with top amenities in SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "dog-park-apartments-beaufort-county",
      "search_query": "apartments with dog park Beaufort County",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Beaufort County",
      "h2_subtitle": "Discover New River Forest's apartments with a dog park, nestled in Beaufort County. It's the perfect home for you and your furry friend.",
      "page_copy": "If you’re looking for a pet-friendly community with ample amenities in Beaufort County, New River Forest is the place for you. Our apartments feature a welcoming environment for your pets with a designated dog park, making it the ideal spot for both you and your furry companions to enjoy.\n\nIn addition to the dog park, you’ll find a variety of amenities designed to make living here a pleasure. Dive into relaxation at our pool, appreciate the luxury flooring, and keep your kids entertained at the playground. Our spacious closets provide ample storage, and we’ll handle the lawn maintenance so you can spend more time enjoying your home. Experience the blend of comfort and convenience at New River Forest.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Beaufort County",
      "seo_description": "Find apartments with a dog park at New River Forest in Beaufort County, SC. Perfect pet-friendly living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "luxury-pool-apartments-bluffton-29910",
      "search_query": "luxury apartments with pool Bluffton 29910",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool, Bluffton 29910",
      "h2_subtitle": "Discover luxury living at New River Forest with a sparkling pool. Located in Bluffton 29910, it offers a premier lifestyle.",
      "page_copy": "Experience the epitome of luxury living at New River Forest in Bluffton, SC, where your apartment comes with resort-style amenities, including a beautiful pool. Perfectly situated in the heart of Bluffton 29910, our community redefines comfort and style, making it the ideal choice for those seeking a lavish lifestyle.\n\nOur luxury apartments are not just about the pool. They feature high-end flooring, spacious closets, and are part of a community that provides a playground and meticulous lawn maintenance. Whether you're swimming laps or lounging poolside, New River Forest offers the perfect blend of relaxation and refinement in Bluffton.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Bluffton, SC",
      "seo_description": "Explore luxury apartments with a pool at New River Forest, Bluffton 29910. Experience sophisticated living in SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "smart-home-apartments-bluffton-sc",
      "search_query": "smart-home technology apartments in Bluffton SC",
      "category": "Amenity",
      "h1_title": "Smart-Home Apartments in Bluffton, SC",
      "h2_subtitle": "Discover the convenience of smart-home technology at New River Forest, Bluffton. Enhance your living experience with modern innovations.",
      "page_copy": "Welcome to New River Forest, where modern innovation meets comfort in Bluffton, SC. Our smart-home technology apartments offer a cutting-edge living experience, allowing you to control lighting, temperature, and more with ease. Situated in beautiful Bluffton, these apartments provide a seamless blend of tech and convenience.\n\nIn addition to state-of-the-art smart-home features, our community boasts a luxurious pool, high-end flooring, and ample storage with spacious closets. The playground provides a fun escape for children, while our dedicated lawn maintenance ensures pristine surroundings year-round. Experience a forward-thinking lifestyle in a vibrant community at New River Forest.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Technology Apartments Bluffton, SC",
      "seo_description": "Find smart-home technology apartments at New River Forest, Bluffton. Experience modern living with advanced amenities in SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "granite-stainless-apartments-bluffton",
      "search_query": "granite countertops and stainless steel appliances apartments Bluffton",
      "category": "Amenity",
      "h1_title": "Apartments with Granite & Stainless Steel in Bluffton",
      "h2_subtitle": "Enjoy modern interiors featuring granite countertops and stainless steel appliances at New River Forest, located in vibrant Bluffton.",
      "page_copy": "At New River Forest, we offer the ultimate in stylish living with our luxurious apartments highlighting granite countertops and stainless steel appliances. These modern features perfectly complement the sophistication and elegance expected by Bluffton residents who seek both function and aesthetic appeal in their homes.\n\nConveniently located in Bluffton, our community goes beyond sleek kitchens. Residents enjoy access to an inviting pool, high-end flooring, and generous closet space. The onsite playground and efficient lawn maintenance add to the family-friendly ambiance. Choose New River Forest for a blend of contemporary living and unmatched comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite & Stainless Steel Apartments Bluffton",
      "seo_description": "Explore apartments with granite countertops and stainless steel appliances at New River Forest, Bluffton. Experience modern living in SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-bluffton-sc",
      "search_query": "four bedroom apartments in Bluffton SC",
      "category": "Floorplan",
      "h1_title": "Spacious Four Bedroom Apartments in Bluffton, SC",
      "h2_subtitle": "Discover our expansive four bedroom apartments at New River Forest, offering ample space and luxury in Bluffton, SC.",
      "page_copy": "Find your perfect home at New River Forest with our spacious four bedroom apartments, ideal for families or those needing extra space in Bluffton, SC. Each apartment is thoughtfully designed with roomy interiors that provide both comfort and style, ensuring a welcoming environment for all residents.\n\nLocated in the vibrant community of Bluffton, our four bedroom layouts are complemented by community features like a beautiful pool, luxury flooring, and convenient playground. With spacious closets and attentive lawn maintenance, New River Forest offers a well-rounded and inviting lifestyle, blending the allure of the South Carolina low country with modern living comforts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Bluffton, SC",
      "seo_description": "Explore four bedroom apartments at New River Forest, Bluffton, SC. Experience ample space and luxury living. Perfect for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-beaufort-county-sc",
      "search_query": "three bedroom apartments Beaufort County SC",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Beaufort County, SC",
      "h2_subtitle": "Explore our comfortable three bedroom apartments at New River Forest, nestled in the heart of Beaufort County, SC, offering spacious living areas.",
      "page_copy": "Experience the charm and convenience of New River Forest with our three bedroom apartments, designed to provide ample space in beautiful Beaufort County, SC. Each apartment boasts generous living areas, making it a perfect choice for those seeking comfort and style in their home.\n\nLocated in scenic Beaufort County, our community features a range of amenities, including a refreshing pool, luxury flooring, and a children's playground. Spacious closets enhance storage options, and our meticulous lawn maintenance ensures a well-kept environment. New River Forest offers an ideal blend of modern living and traditional Southern hospitality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Beaufort County, SC",
      "seo_description": "Find spacious three bedroom apartments at New River Forest in Beaufort County, SC. Enjoy modern living with style and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "apartments-near-usc-beaufort-bluffton-campus",
      "search_query": "apartments near university of south carolina beaufort bluffton campus",
      "category": "School",
      "h1_title": "Convenient Apartments Near USC Beaufort Bluffton",
      "h2_subtitle": "Live close to the University of South Carolina Beaufort Bluffton Campus at New River Forest, offering comfort and convenience.",
      "page_copy": "Discover the perfect living solution at New River Forest, situated conveniently near the University of South Carolina Beaufort Bluffton Campus. Our apartments are ideally located for students, faculty, and staff seeking a short commute and the comforts of home while staying connected to campus life.\n\nNew River Forest offers a range of amenities, including a sparkling pool for relaxation, luxury flooring for added sophistication, and extensive closet spaces for storage. With our family-friendly playground and dedicated lawn maintenance, our community provides a welcoming environment ideal for balancing academic commitments and personal time.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near USC Beaufort Bluffton Campus",
      "seo_description": "Find convenient apartments near USC Beaufort Bluffton Campus at New River Forest. Experience the comfort of home close to school.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "apartments-near-new-riverside-barn-park-bluffton",
      "search_query": "apartments near new riverside barn park bluffton",
      "category": "Park",
      "h1_title": "Live Near New Riverside Barn Park in Bluffton",
      "h2_subtitle": "Enjoy easy access to New Riverside Barn Park when you reside at New River Forest, offering a tranquil haven in Bluffton.",
      "page_copy": "Reside at New River Forest and enjoy superb proximity to the picturesque New Riverside Barn Park in Bluffton. Our community offers the perfect blend of accessible parkland and modern conveniences, making it ideal for nature lovers and outdoor enthusiasts.\n\nThese well-appointed apartments provide a comfortable home base complete with luxury flooring, ample closet space, and stunning pool views. Family-friendly amenities like a playground, along with meticulous lawn maintenance, ensure a welcoming environment. At New River Forest, you can relish the serenity of nearby natural beauty while enjoying the comforts of exceptional living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near New Riverside Barn Park, Bluffton",
      "seo_description": "Discover tranquil living at New River Forest, near New Riverside Barn Park in Bluffton. Enjoy nature and modern comfort in harmony.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167581",
      "source": "generator",
      "page_item_url": "rentals-close-to-hardeeville-dog-park-sc",
      "search_query": "rentals close to hardeeville dog park sc",
      "category": "Park",
      "h1_title": "Rentals Near Hardeeville Dog Park, SC",
      "h2_subtitle": "Find pet-friendly rentals near Hardeeville Dog Park at New River Forest, where both you and your furry friends will feel at home.",
      "page_copy": "If you're searching for a pet-friendly community close to Hardeeville Dog Park, look no further than New River Forest. Offering comfortable and stylish accommodations, our rentals provide an ideal location for pet owners who enjoy spending quality time outdoors with their furry companions.\n\nNew River Forest boasts spacious interiors, perfect for you and your pets, along with amenities like a refreshing pool and luxury flooring. Our spacious closets and playground ensure that every family member, whether two-legged or four, has plenty of room to roam and play. Plus, our expert lawn maintenance ensures green and inviting surroundings for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Hardeeville Dog Park, SC",
      "seo_description": "Explore pet-friendly rentals at New River Forest, near Hardeeville Dog Park, SC. Enjoy comfort and outdoor fun with your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977274608"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P737RFCN"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57151089588"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/40vl39xrvle"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/a545ca50-8c91-487c-bb91-605729d47da0/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f57669d2-ff93-11ef-9463-9794bc9a70e0"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-405-4938"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "855-787-7442"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977274608",
  "custom_google_gtm_id": "GTM-P737RFCN",
  "custom_rollout_phase": "Phase 1",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57151089588",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/40vl39xrvle",
  "custom_self_guided_tour_url": "https://selftournow.com/property/a545ca50-8c91-487c-bb91-605729d47da0/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f57669d2-ff93-11ef-9463-9794bc9a70e0",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "844-405-4938",
  "custom_paid_social_tracking_phone_number": "855-787-7442",
  "custom_audioeye_site_id": "de129ea6-79fd-4086-ae1c-5aa08db26815",
  "custom_audioeye_site_hash": "6649fe784034340e27126b86d5cd39fe"
};

export const generatedAt = '2026-10-29T18:34:50.239Z';
